import React,{useState,useEffect}  from 'react'
import {Database} from "./Firebase/Firebase"
import {Container, Row, Col,Button,Badge,Form } from "react-bootstrap";
import {Link} from "react-router-dom";
import useLocalStorage from "./LocaleStorage/UseLocaleStorage";
import NavBar from "./NavBar"
import Footer from "./Footer"
const Woman = () => {
    const [articleWomane,setArticleWomane]=useState([]);
    const [articleToSend,setArticleToSend]=useLocalStorage("Article");
    useEffect(()=>{
        ReadDataFromDatabaseSabot();
    },[])
    const ReadDataFromDatabaseSabot = ()=>{
        const articleSabot = Database.database().ref("WomanArticles")
        articleSabot.on("value",(snapShot)=>{
          const data= snapShot.val();
          let  list = [];
            for( let id in data)
             {
               list.push({id,...data[id]})
             }
             setArticleWomane(list)
        })
    }

    return (
        <>
        <NavBar/>
               <h2 className="section__title title__woman">لكي سيدتي</h2>
               <h6 className=" section__title Subtitle">إضغط (ي) على المنتج لمزيد من معلومات حوله</h6>
                        <Container className="featured__container bd_grid">
                        <Row>
                            {articleWomane.map((articleWomanP)=>(
                            <Col key={articleWomanP.id} lg={4} md={6} sm={6} xs={4} className="featured__product">
                                 <Link onClick={()=>setArticleToSend(articleWomanP)} to={`/Confirmation/:${articleWomanP.id}`} className="Cardhover">
                                <div className="cardF">
                                    <div className="featured__box">
                                        <Badge className="featured__new">Promo</Badge>
                                        <img src={articleWomanP.urlToUse} className="featured__img" alt="Product"/>
                                    </div>
                                    <div className="featured__data">
                                        <span className="text-center underLine">{`${(articleWomanP.prix*1.5)} DH`}</span>        
                                        <span className="featured_preci">
                                            {`${articleWomanP.prix} DH`}
                                        </span>
                                        
                                        <Link className="buttonComanderLink" to={`/Confirmation/:${articleWomanP.id}`}>
                                            <Button onClick={()=>setArticleToSend(articleWomanP)} className="buttonComander text-center buttonComanderLinke" variant="primary">                                             
                                                        Commander
                                            </Button>
                                        </Link> 
                                    </div>
                                </div>
                                </Link>
                            </Col>))}
                        </Row>
                    </Container>
                    <Footer/>
        </>
    )
}

export default Woman
